import React, { Component } from 'react'
import {CheckboxGroupInput, required} from 'react-admin'
import TileCheckField from './TitleCheckField'
import styles from './css/styles.module.css'

class TitleCheckCom extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [], flag: false };
    }
  /*
    componentDidMount() {
        fetch(`/usertitles`)
          .then(res => res.json())
          .then(json => this.setState({ data: json , falg: true}));
        
    }

    componentWillUnmount() {
        this.setState({ flag: false, data: [] })
    }

    render(props) {
        var source = this.props && this.props.source? this.props.source : 'level'
        var label = this.props && this.props.label ? this.props.label : 'Title/Role'
        console.log(source)
        console.log(this.state.data)
        return (
             this.state.flag ? <CheckboxGroupInput  source={source}    label={label} choices={this.state.data}  />: null
        );
      }
    */

   render () {
      
    return <TileCheckField props={this.props}/>
    }
}

export default TitleCheckCom 